export default "__VITE_ASSET__B98w2kaI__"